import React, { Component } from "react";
import PropTypes from "prop-types";

// Packages
import shortid from 'shortid';

class ProfileHeaderStats extends Component {

  static propTypes = {
    profile: PropTypes.object.isRequired,
    participation: PropTypes.object.isRequired
  }

  statList = (props) => {
    return props.keyMetrics
    ? this.defaultStatList(props).concat(this.sportSpecificStatList(props))
    : this.defaultStatList(props)
  }

  defaultStatList = (props) => (
    [
      {
        label: 'Jersey',
        stat: props.participation.jersey_number
      },
      {
        label: 'Position',
        stat: props.participation.primary_positions.map(pp => pp.abbreviation).join(", ")
      },
      {
        label: 'Height',
        stat: props.profile.height_us_feet + '\' ' + props.profile.height_us_inches + '"'
      },
      {
        label: 'Weight',
        stat: props.profile.weight_lbs
      }
    ]
  )

  sportSpecificStatList = (props) => {
    const sportSpecificStats = props.participation.sport_specific_stats

    return Object.keys(sportSpecificStats).map(property => (
      {label: property, stat: sportSpecificStats[property]}
    ))
  }

  render() {
    return (
      <div className="profile-header-stats">
        <div className="inner-wrap">
          {this.statList(this.props).map((stat) => {
            return stat.stat
            ? (
              <div className="profile-header-stats-statistic" key={shortid.generate()}>
                <div className="profile-header-stats-statistic-title">
                  {stat.label}
                </div>
                <div className="profile-header-stats-statistic-rating">
                  {stat.stat}
                </div>
              </div>
            ) : null
          })}
        </div>
      </div>
    );
  }
}

export default ProfileHeaderStats;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileHeaderStats.js